<template>
  <v-main>
    <v-container class="my-8" style="max-width: 900px">
      <v-card elevation="3" rounded="xxl" class="pa-4 pa-sm-6">
        <v-card-title>
          <h2 class="text-h5 font-weight-bold mb-1">Terms &amp; Conditions</h2>
        </v-card-title>
        <v-card-subtitle>
          Last updated: {{ lastUpdated }}
        </v-card-subtitle>
        <v-divider class="mb-4"></v-divider>
        <v-card-text class="legal-content text-body-1">
          <p>
            Welcome to <strong>Oggy Kart</strong>. By accessing or using our
            application and services, you agree to be bound by these Terms &amp;
            Conditions. Please read them carefully before using the platform.
          </p>

          <h3>1. Acceptance of Terms</h3>
          <p>
            By creating an account, placing an order, or using any feature of
            Oggy Kart, you confirm that you have read, understood, and agreed
            to these Terms. If you do not agree, please do not use the service.
          </p>

          <h3>2. Eligibility</h3>
          <p>
            You must be at least 18 years of age to use Oggy Kart. By using the
            platform, you represent that you meet this requirement and that the
            information you provide is accurate and complete.
          </p>

          <h3>3. Account &amp; Security</h3>
          <ul>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You are responsible for all activities that occur under your account.</li>
            <li>Notify us immediately of any unauthorized access or security breach.</li>
          </ul>

          <h3>4. Orders, Pricing &amp; Payments</h3>
          <p>
            All prices listed on the platform are inclusive of applicable taxes
            unless stated otherwise. Oggy Kart reserves the right to modify
            prices, accept or decline any order, and cancel orders in cases of
            pricing errors, stock unavailability, or suspected fraudulent
            activity.
          </p>

          <h3>5. Delivery</h3>
          <p>
            Delivery times are estimates and may vary based on your location,
            product availability, and external factors. Oggy Kart is not liable
            for delays caused by circumstances outside its reasonable control.
          </p>

          <h3>6. Cancellations, Returns &amp; Refunds</h3>
          <p>
            Orders may be cancelled before dispatch. Returns and refunds are
            subject to our refund policy and product eligibility. Refunds, when
            applicable, will be processed to the original payment method.
          </p>

          <h3>7. User Conduct</h3>
          <p>You agree not to:</p>
          <ul>
            <li>Use the platform for any unlawful or fraudulent purpose.</li>
            <li>Upload or transmit harmful or offensive content.</li>
            <li>Attempt to gain unauthorized access to our systems.</li>
            <li>Interfere with other users' use of the platform.</li>
          </ul>

          <h3>8. Intellectual Property</h3>
          <p>
            All content on Oggy Kart — including logos, text, graphics, and
            software — is the property of Oggy Kart or its licensors and is
            protected by applicable intellectual property laws.
          </p>

          <h3>9. Limitation of Liability</h3>
          <p>
            To the maximum extent permitted by law, Oggy Kart shall not be
            liable for any indirect, incidental, or consequential damages
            arising from your use of the platform.
          </p>

          <h3>10. Changes to the Terms</h3>
          <p>
            We may update these Terms from time to time. Continued use of the
            platform after changes are posted constitutes your acceptance of
            the revised Terms.
          </p>

          <h3>11. Contact Us</h3>
          <p>
            If you have any questions about these Terms, please contact us via
            the support section in the app.
          </p>
        </v-card-text>

        <v-card-actions class="justify-center pb-4">
          <v-btn outlined color="primary" to="/login">Back to Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "TermsAndConditionsPage",
  data() {
    return {
      lastUpdated: "April 15, 2026",
    };
  },
};
</script>

<style scoped>
.legal-content h3 {
  margin-top: 1.25rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.legal-content p {
  margin-bottom: 0.75rem;
  line-height: 1.7;
}
.legal-content ul {
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}
.legal-content li {
  margin-bottom: 0.25rem;
}
</style>
